import * as React from 'react';
import classnames from 'classnames';
import { usePrefixCls } from '../_utils';
import { FormProps } from './interface';

const Form: React.FC<FormProps> = props => {
  const { className, layout = 'vertical', style, children, readOnly, split } = props;
  const prefixCls = 'unv-form';
  const comCls = usePrefixCls('form');

  const formClassName = classnames(
    prefixCls,
    comCls,
    {
      [`${prefixCls}--${layout}`]: layout && layout !== 'horizontal',
      'is-readonly': readOnly,
      [`${comCls}--split`]: !!split
    },
    className,
  );

  return (
    <div className={formClassName} style={style}>
      {children}
    </div>
  );
};

export default Form;
